import * as React from 'react'
import { useEffect } from 'react'

import { useJourneysData2 } from '../../hooks/journeys/useJourneysData2'
import MapControls from './MapControls'
import JourneyMap2 from '../maps/apps/JourneyMap2'
import LoadingModal from '../modals/LoadingModal'
import MapFilterPopup from './MapFilterPopup'

const AppWrapper2 : React.FC = () => {
  const {
    view, mapRef, showAirJourneyForm,
    loading, showMapFilterPopup,
  } = useJourneysData2()

  useEffect(() => {
    mapRef.current.resize()
  }, [view, showAirJourneyForm])

  return (
    <>
      <LoadingModal isOpen={loading} />
      <MapControls />
      <JourneyMap2 />
      { showMapFilterPopup && <MapFilterPopup /> }
    </>
  )
}

export default AppWrapper2
